var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteBin({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.63875 3.33984L7.26375 3.98859L2.715 1.36359L3.09 0.714844L4.23 1.37109L4.74 1.23234L6.36375 2.16984L6.5025 2.68359L7.63875 3.33984ZM2.25 7.12359V2.62359H4.15125L6.75 4.12359V7.12359C6.75 7.32251 6.67098 7.51327 6.53033 7.65392C6.38968 7.79458 6.19891 7.87359 6 7.87359H3C2.80109 7.87359 2.61032 7.79458 2.46967 7.65392C2.32902 7.51327 2.25 7.32251 2.25 7.12359Z",
    fill: "#949494"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteBin);
export default __webpack_public_path__ + "static/media/delete_bin.a2e68956610cc8415988904e7a70047c.svg";
export { ForwardRef as ReactComponent };